module.exports = __webpack_public_path__ + "static/media/bcsgQAScreen5.1f3b79cc.jpg";